//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getStudySummary} from '@/api/iapc'

export default {

  data() {
    return {
      div_height:0,
      sing:false,
      is_show_study_more:true,
      is_show_comment_more:true,
      is_show_video_more:true,
      teacherId:'',
      summaries:[],
      classrooms:[],
      classes:{},
      summari:{},
      commentInfo:[],
      studyInfo:[],
      videoInfo:[],
      studys:false,
      comments:false,
      videos:false,
    };
  },
  components: {

  },
  methods: {
    down_up(sing){
        var div = $('.open_div')
        if(sing){
          this.sing = false;
          $("#icon").attr("src",'../../../static/images/iapc/xia.png')
          div.slideDown('400', ()=> {
            /*$(this).find("li").bind("click",function(){
              var selectLi=$(this).text();
              $("#select span").text(selectLi);
              $("#select ul").slideUp(400);
            })
            ul.mouseleave(function() {
              $('#select ul').slideUp(400)
            });*/
          });

        }else{
          this.sing = true;
          $("#icon").attr("src",'../../../static/images/iapc/shang.png')
        }
    },
    drawLine(){
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('myChart'))
      // 绘制图表
      myChart.setOption({

        tooltip : {
          trigger: 'item',
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        series : [
          {
            name: '访问来源',
            type: 'pie',
            radius : ['0%','80%'],
            center: ['50%', '50%'],
            label: {
              normal: {
                show: true,
                position: 'inside'
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '30',
                  fontWeight: 'bold'
                }
              }
            },
            color:['#2C82BE', '#DBECF8'],
            data:[
              {value:this.summari.studyNumber, name:this.summari.studyNumber, selected:true},
              {value:this.summari.unbindNumber, name:this.summari.unbindPer},
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      });
    },
    more(type){
        if(type == 'study_more'){
            this.studys = true;
            this.is_show_study_more = false;
        }else if(type == 'comment_more'){
            this.comments = true;
            this.is_show_comment_more = false;
        }else{
            this.videos = true;
            this.is_show_video_more = false
        }
    },
    select(obj){
        this.sing = false;
        $("#icon").attr("src",'../../../static/images/iapc/xia.png');
        for(var i=0;i<this.summaries.length;i++){
            if(this.summaries[i].classroomId == obj.id){
              this.summari = this.summaries[i];
            }
        }
        $('#classes_name').text(obj.name)
        this.commentInfo = this.summari.commentInfo;
        this.studyInfo = this.summari.studyInfo;
        this.videoInfo = this.summari.videoInfo;
        var per = (this.summari.studyNumber/this.summari.total)*100;
        per = per.toFixed(0);
        this.summari.studyPer = per;
        var per2 = (this.summari.unbindNumber/this.summari.total)*100;
        per2 = per2.toFixed(0);
        this.summari.unbindPer = per2;
        this.drawLine();
    },
    getStudySummaryInfo(){

      let params = {teacherId:this.teacherId}
      getStudySummary(params).then((res) => {
        if(res.code == 0){
            this.classrooms = res.data.classrooms;
            this.classes = this.classrooms[0];
            this.summaries = res.data.summaries;
            this.summari = this.summaries[0];
            this.commentInfo = this.summari.commentInfo;
            this.studyInfo = this.summari.studyInfo;
            this.videoInfo = this.summari.videoInfo;
            if(this.studyInfo.length == 0){
              this.is_show_study_more = false;
            }

            if(this.commentInfo.length == 0){
              this.is_show_comment_more = false;
            }

            if(this.videoInfo.length == 0){
              this.is_show_video_more = false;
            }

            var per = (this.summari.studyNumber/this.summari.total)*100;
            per = per.toFixed(0);
            this.summari.studyPer = per;
            var per2 = (this.summari.unbindNumber/this.summari.total)*100;
            per2 = per2.toFixed(0);
            this.summari.unbindPer = per2;
            this.drawLine();
        }

      })
    },

  },
  mounted () {
    this.div_height = $(window).height();
    if (typeof(this.$route.query.teacherId) != "undefined" || this.$route.query.teacherId != ""){
      this.teacherId = this.$route.query.teacherId;
      this.getStudySummaryInfo();
    }
  },
};





// WEBPACK FOOTER //
// ./src/pages/iapc/survey.vue